<div class="tab-details-sheet"
    [@slidePageSheetWidth]="sheetWidth$$()"
    (@slidePageSheetWidth.start)="emit_animation_start()"
    (@slidePageSheetWidth.done)="emit_animation_end()"
    [class]="sheetWidth$$()" 
>
    <div class="banner-box">
        @if (!isListPage$$() && photo_show$$()) {
            <div class="image-box" 
                [@resizeImageBox]="photo_size$$()"
            >
                <ng-container *ngTemplateOutlet="imageBlock" />
            </div>
        }
        @if (sectionCompact_show$$()) {
            <div class="compact-box" @showHide>
                <ng-container *ngTemplateOutlet="sectionCompact_template$$()" />
            </div>
        }
    </div>
    @if (sectionDetails_show$$()) {
        <div class="controls-box" [@slideControlsBox]="{ value: '', params: { enterTime: _motionDuration$$(), leaveTime: _motionDuration$$() } }">
            <app-section-details 
                (btnCancel)="emit_btnCancel()"
                (btnDelete)="emit_btnDelete()"
                (btnEdit)="emit_btnEdit()"
                (btnSave)="emit_btnSave()"
            />
        </div>
    }
</div>
 
<ng-template #imageBlock>
    <image-box-details
        (fileSelectEmit)="emit_photoUpload($event)"
        (onClickEmit)="emit_photoClick()"
        [border]="true"
        [canUpload]="photoCanUpload$$()"
        [dragActive]="photoDragActive$$()"
        [dropEnabled]="photoDropEnabled$$()"
        [guid]="photo_guid$$()"
        [noClick]="noClick$$()"
        [version]="photo_version$$()"
    />
</ng-template>
